<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>试用申请</BreadcrumbItem>
      <BreadcrumbItem>申请列表</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <div style="text-align: right; width: 400px; margin: 0 auto 20px">
        <Input v-model.trim="searchMobile" @on-enter="search(1)" size="large" placeholder="输入手机号搜索">
          <Button slot="append" type="primary" icon="ios-search" @click="search(1)">搜索</Button>
        </Input>
      </div>
      <Card >
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          申请列表
          <Input >
          <Button slot="append" icon="ios-search"></Button>
          </Input>
        </p>
        <Table :columns="columns" :data="rows" :show-header="true"></Table>
        <Page :total="totalCount" :page-size="pageSize" :current.sync="currentPage" show-total show-elevator @on-change="handlePageChange" style="margin-top: 10px; text-align: right" />
      </Card>
    </div>
    <Modal
        v-model="showNoteModal"
        title="编辑备注"
        :mask-closable="false"
        @on-ok="handleConfirmNote()"
        :styles="{top: '10px'}"
        width="700"
    >
      <Form ref="formValidate" label-position="top" >
        <FormItem label="备注">
          <Input v-model.trim="newNote" type="textarea"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'

export default {
  name: 'ApplyRequestList',
  data () {
    return {
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      searchMobile: '',
      remoteStatus: null,
      applyRequestList: [],
      newNote: '',
      updateNoteRequestId: null,
      showNoteModal: false,
      columns: [
        {
          title: '申请时间',
          key: 'createDate',
          render: (h, params) => {
            return h('span', this.formatDate(params.row.createDate))
          }
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '公司名称',
          key: 'companyName'
        },
        {
          title: '手机',
          key: 'contactPhone'
        },
        {
          title: '邮箱',
          key: 'contactEmail'
        },
        {
          title: '备注',
          key: 'adminNote'
        },
        {
          title: '操作',
          width: 100,
          key: 'operation',
          render: (h, params) => {
            let elements = []
            elements.push(
              h('p', [h('Button', {
                props: {
                  type: 'default',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.toShowNoteModal(params.row)
                  }
                }
              }, '编辑备注')])
            )
            return h('div', elements)
          }
        }
      ]
    }
  },
  computed: {
    rows () {
      return this.applyRequestList
    }
  },
  methods: {
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
    },
    toShowNoteModal (request) {
      this.newNote = request.adminNote
      this.updateNoteRequestId = request.id
      this.showNoteModal = true
    },
    async handleConfirmNote () {
      try {
        this.beforeSave()
        await this.$http.patch(`/api/admin/applyRequest/${this.updateNoteRequestId}/adminNote`, {adminNote: this.newNote})

        let matchedIndex = -1
        this.applyRequestList.forEach((item, index) => {
          if (item.id === this.updateNoteRequestId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.applyRequestList[matchedIndex].adminNote = this.newNote
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    handlePageChange () {
      this.search(this.currentPage)
    },
    async search (startPage) {
      try {
        this.$Loading.start()
        let queryStr = `?page=${startPage}&size=${this.pageSize}`

        if (this.searchMobile) {
          queryStr += `&mobile=${this.searchMobile}`
        }

        let resp = await this.$http.get(`/api/admin/applyRequest${queryStr}`)
        this.totalCount = resp.body.totalElements
        this.totalPage = resp.body.totalPages
        this.applyRequestList = resp.body.content
        this.$Loading.finish()
      } catch (e) {
        console.log(e)
        this.afterSave(e)
      }
    }
  },

  async beforeRouteEnter (to, from, next) {
    try {
      let resp = await Vue.http.get('/api/admin/applyRequest?page=1&size=20')
      next(vm => {
        vm.remoteStatus = resp.status
        vm.applyRequestList = resp.body.content
        vm.totalCount = resp.body.totalElements
        vm.totalPage = resp.body.totalPages
        vm.searchMobile = null
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.applyRequestList = []
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply/ApplyRequestList.vue